
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
class AboutMe extends Vue {
}

export default AboutMe;
